import { User } from '@/features/users';
import { cimAxiosClient } from '@/lib';
import { ApiResponse } from '@/types';

import { cimAPIUrls } from '../data';

type Params = {
  company_id: User['legacy_company_id'];
  access_token: string;
  user_id: User['legacy_user_id'];
};

type Return = {
  success: boolean;
  message: string;
};

export type GetADEConnection = {
  params: Params;
  return: Return;
};

export const getADEConnect = async (params: Params): Promise<Return> => {
  const response = await cimAxiosClient.get<ApiResponse<Return>>(
    cimAPIUrls.adeConnect,
    {
      params: {
        company_id: params.company_id,
        user_id: params.user_id,
        access_token: params.access_token,
      },
    },
  );

  return response.data;
};
